/* eslint-disable max-classes-per-file */
import { OnDestroy } from '@angular/core';
import { Constructor } from '@utils/types/constructor.type';
import { SubSink } from 'subsink';

export function Unsubscriber<TBase extends Constructor>(Base: TBase = class {} as any) {
  return class extends Base implements OnDestroy {
    private _subsink!: SubSink;

    get subsink(): SubSink {
      if (!this._subsink) {
        this._subsink = new SubSink();
      }
      return this._subsink;
    }

    /**
     * @Warn Don't forget to call the super method if
     * override is needed.
     */
    ngOnDestroy(): void {
      this._subsink?.unsubscribe();
    }
  };
}
